export const cards10Caracteristicas = [
  {
    id: '1',
    linkVideo: 'https://www.youtube.com/embed/AnUEsOB2sjg?enablejsapi=1',
    title: 'Busca de oportunidade e iniciativa',
    desc: 'Permite ao empreendedor explorar novos mercados e expandir seu negócio, criando uma vantagem competitiva e antecipando-se a mudanças do mercado.',
  },
  {
    id: '2',
    linkVideo: 'https://www.youtube.com/embed/g2rTbcwYal8?enablejsapi=1',
    title: 'Correr riscos calculados',
    desc: 'Habilita o empreendedor a fazer escolhas mais seguras, maximizando as chances de retorno e reduzindo as possibilidades de perdas significativas.',
  },
  {
    id: '3',
    linkVideo: 'https://www.youtube.com/embed/yK4fkcXW514?enablejsapi=1',
    title: 'Exigência de qualidade e eficiência',
    desc: 'Contribui para a excelência operacional e satisfação dos clientes, além de reduzir custos e aumentar a competitividade.',
  },
  {
    id: '4',
    linkVideo: 'https://www.youtube.com/embed/fs8EAGGd09A?enablejsapi=1',
    title: 'Persistência',
    desc: 'Ajuda o empreendedor a superar desafios e a não desistir perante fracassos temporários, aumentando a resiliência e a probabilidade de sucesso.',
  },
  {
    id: '5',
    linkVideo: 'https://www.youtube.com/embed/2ZlNp3aZWrU?enablejsapi=1',
    title: 'Comprometimento',
    desc: 'Constrói uma relação de confiança com clientes, parceiros e colaboradores, fortalecendo a reputação do empreendedor e seu comprometimento com resultados.',
  },
  {
    id: '6',
    linkVideo: 'https://www.youtube.com/embed/-24BeWghnEs?enablejsapi=1',
    title: 'Busca de informação',
    desc: 'Fornece insights valiosos, permitindo decisões mais embasadas, melhor adaptação ao mercado e identificação de tendências.',
  },
  {
    id: '7',
    linkVideo: 'https://www.youtube.com/embed/OJ7lJ3lP9J8?enablejsapi=1',
    title: 'Estabelecimento de metas',
    desc: 'Facilita o foco e a orientação estratégica, ajudando o empreendedor a alcançar seus objetivos com mais eficiência.',
  },
  {
    id: '8',
    linkVideo: 'https://www.youtube.com/embed/bfKIO_CH9DI?enablejsapi=1',
    title: 'Planejamento e monitoramento sistemático',
    desc: 'Melhora a execução de projetos, garante o cumprimento de prazos e ajuda o empreendedor a manter o controle sobre o negócio.',
  },
  {
    id: '9',
    linkVideo: 'https://www.youtube.com/embed/8NfEMJHg61g?enablejsapi=1',
    title: 'Persuasão e rede de contatos',
    desc: 'Amplia oportunidades de parcerias e networking, abrindo portas para novas colaborações e suporte nos negócios.',
  },
  {
    id: '10',
    linkVideo: 'https://www.youtube.com/embed/fTOpehv4FqU?enablejsapi=1',
    title: 'Independência e autoconfiança',
    desc: 'Fortalece a autossuficiência e a tomada de decisões, ajudando o empreendedor a liderar com mais segurança e a enfrentar adversidades com assertividade.',
  },
];
